import React  from 'react';
import { useQuery } from '@apollo/react-hooks';
import { withStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import LinearProgress from '@material-ui/core/LinearProgress';
import { GET_STUDENT_WORKSHEETS } from 'graphql/student/milestones';
import Helmet from "react-helmet";
import ExerciseListItem from '../timeline/components/ExerciseListItem';

const Accordion = withStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(2),
    '&:not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      // margin: 'auto',
      marginBottom: theme.spacing(4),

    },
  },
  expanded: {},
}))(MuiAccordion);

const AccordionSummary = withStyles((theme) => ({
  root: {
    // backgroundColor: 'rgba(0, 0, 0, .03)',
    // borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
      borderBottom: '1px solid rgba(0, 0, 0, .125)',
    },
    flexDirection: 'row-reverse',
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
      '& .MuiTypography-root': {
        color: theme.palette.primary.main,
      },
    },
  },
  expandIcon: {
    '&$expanded':{
      color: theme.palette.primary.main,
    },
  },
  expanded: {},
}))(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

const Worksheets = (props) => {
  const user = useSelector((s) => s.user.user);
  const profile = useSelector((s) => s.student.profile);
  const { loading, error, data } = useQuery(GET_STUDENT_WORKSHEETS, {
    variables: { userId: user.id },
  });

  if (loading) {
    return (
      <div>
        <LinearProgress />
      </div>
    );
  }

  if (error) {
    return <div>Error</div>;
  }

  return (
    <Grid container justify="center">
      <Helmet title="Exercises" />
      <Grid item md={7}>
        {data?.modules.map(module => (
          <Accordion key={module.id}>
            <AccordionSummary expandIcon={<ArrowDropDownIcon />} IconButtonProps={{
              edge: 'start',
              color: 'inherit',
            }}>
              <Typography variant="body2">{module.name}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box flex={1}>
                {module.exercises.filter(e => e.student_milestone_exercises.length).map(ex => (
                  <ExerciseListItem
                    key={ex.id}
                    module={module}
                    exercise={ex}
                    studentExercise={ex.student_milestone_exercises[0]}
                    user={user}
                    from='library'
                  />
                ))}
              </Box>
            </AccordionDetails>
          </Accordion>
        ))}
      </Grid>
    </Grid>
  );
};

export default Worksheets;
